import React from "react";
import { SVGIconProps } from "./SVGIconProps";
function Dot(props: SVGIconProps) {
    const { width = 6, height = 6, fillColor = "#219342", onClick } = props;
    return (
        <svg width={width}
            height={height} viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill={fillColor} />
        </svg>

    );
}
export default Dot;
